export default __webpack_public_path__ + "static/board-375b1df747cad525567cc836cb9c6f5f.png";